var map = {
	"./en.json": "./src/locales/message/en.json",
	"./ko.json": "./src/locales/message/ko.json"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/locales/message lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;